import {FC} from 'react';
import style from './style.module.scss';
import Picture from 'components/Picture';
import {useIsSkeleton} from 'modules/skeleton/hooks/useIsSkeleton';
import cs from 'classnames';
import {useInView} from 'react-intersection-observer';
import {useBannerViewGtag} from 'hooks/analytics/gtag/banners/useBannerViewGtag';
import {ICatalogBanner} from 'modules/products/types';
import {BANNER_LIST_INDEX} from 'modules/products/components/CatalogProductList/constants';
import {useBannerClickGtag} from 'hooks/analytics/gtag/banners/useBannerClickGtag';
import {IAnalyticsMeta} from 'core/types';
import {useSanitizeString} from 'core/hooks/useSanitizeString';

interface IProps extends ICatalogBanner {
    view?: 'list' | 'tile';
    bannerIndex?: number;
    analytics?: IAnalyticsMeta;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductBannerCard: FC<IProps> = ({view, analytics, ...banner}) => {
    const {title, link, image} = banner;
    const isSkeleton = useIsSkeleton();
    const pureTitle = useSanitizeString(title);

    const bannerViewGtag = useBannerViewGtag();
    const {ref} = useInView({
        triggerOnce: true,
        threshold: 0.5,
        onChange: (inView) => {
            if (inView) {
                bannerViewGtag({
                    type: 'common',
                    banners: [
                        {
                            ...banner,
                            position: analytics?.positionIndex ?? BANNER_LIST_INDEX,
                        },
                    ],
                    creative: 'snippet__banner',
                    enableTracking: true,
                });
            }
        },
    });

    const bannerClickGtag = useBannerClickGtag();

    const handleBannerClick = () => {
        bannerClickGtag({
            type: 'common',
            banner: {
                ...banner,
                position: analytics?.positionIndex ?? BANNER_LIST_INDEX,
            },
            creative: 'snippet__banner',
        });
    };

    return (
        <div className={cs({[style.bannerCardList]: 'list' === view})} ref={ref} onClick={handleBannerClick}>
            <a className={cs(style.bannerCard)} href={link}>
                {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                <div className={style.title} dangerouslySetInnerHTML={{__html: pureTitle}} />
                {!isSkeleton && <Picture src={image} />}
            </a>
        </div>
    );
};
